import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Toast } from 'primeng/toast';

import { LoaderService } from '@shared/components';
import { ToastBridgeService } from '@shared/services';
import { LanguageService } from './i18n';
import { AccountLoadersService, AccountMessagesService } from './core/libraries';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [RouterOutlet, ConfirmDialog, Toast],
    providers: [AccountLoadersService, AccountMessagesService],
})
export class AppComponent implements OnInit {
    readonly loaderService = inject(LoaderService);
    private readonly languageService = inject(LanguageService);
    private readonly toastBridgeService = inject(ToastBridgeService);
    private readonly accountMessagesService = inject(AccountMessagesService);

    ngOnInit(): void {
        this.languageService.init();
        this.toastBridgeService.init();
    }
}
